import { __extends } from "tslib";
import { deserializeAws_restXmlDeleteBucketLifecycleCommand, serializeAws_restXmlDeleteBucketLifecycleCommand } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteBucketLifecycleCommand = /** @class */ (function (_super) {
    __extends(DeleteBucketLifecycleCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteBucketLifecycleCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteBucketLifecycleCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteBucketLifecycleCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlDeleteBucketLifecycleCommand(input, context);
    };
    DeleteBucketLifecycleCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlDeleteBucketLifecycleCommand(output, context);
    };
    return DeleteBucketLifecycleCommand;
}($Command));
export { DeleteBucketLifecycleCommand };
//# sourceMappingURL=DeleteBucketLifecycleCommand.js.map